import {
    BookingConfigResponse,
    CompanyInfoResponse,
    CountriesResponse,
    Country,
    ModuleConfigResponse
} from "../../types/apiTypes";
import { apiSlice } from "./apiSlice";

export const settingsInjectedEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getModuleConfig: builder.query<ModuleConfigResponse, void>({
            query: () => "/settings/available_modules",
            providesTags: ["ModuleConfig"]
        }),

        getServerTimeZone: builder.query<string, void>({
            query: () => "/settings/server_time_zone",
            providesTags: ["ServerTimeZone"]
        }),

        getCompanyInfo: builder.query<CompanyInfoResponse, void>({
            query: () => "/settings/company_info",
            providesTags: ["CompanyInfo"]
        }),

        getBookingConfig: builder.query<BookingConfigResponse, void>({
            query: () => "/settings/booking_config",
            providesTags: ["BookingConfig"]
        }),

        getCountries: builder.query<Country[], void>({
            query: () => "/settings/countries",
            transformResponse: (response: CountriesResponse) => {
                // Position a copy of Canada and USA at beginning of the list.
                const countries = response.data;
                const canada = countries.find((country) => country.name === 'Canada');
                const unitedStates = countries.find((country) => country.name === 'United States');

                canada && countries.unshift(canada);
                unitedStates && countries.unshift(unitedStates);

                return countries
            }
        })
    })
});

export const settingsEndpoints = settingsInjectedEndpoints.endpoints;
export const {
    useGetModuleConfigQuery,
    useGetServerTimeZoneQuery,
    useGetCompanyInfoQuery,
    useGetBookingConfigQuery,
    useGetCountriesQuery
} = settingsInjectedEndpoints;
